import hasPageMeta from '@/mixins/hasPageMeta'

export default {
    mixins: [hasPageMeta],

    computed: {
        computedPageTitle() {
            if (this.$route.query.step) return `${this.pageTitle} Setup - ${this.$route.query.step}`
            return `${this.pageTitle}`
        },

        siteTitle() {
            return this.computedPageTitle
        },

        siteDescription() {
            return 'Need a free wedding checklist? Here are 3 options including a free printable wedding planning checklist PDF, & a do it yourself simple wedding checklist online'
        },

        previewImage() {
            return require('@/static/checklist/checklist-preview-image.jpg')
        },

        keywords() {
            return 'free wedding planning checklist'
        },
    },

    data() {
        return {
            pageTitle: 'Free Wedding Checklist PDF: Simple Printable Wedding Planning Checklist PDF',
        }
    },
}
